import {IMAGE_DEFAULT_FORMATS} from "../../app/consts";
import {SportViewModel} from "../../../domain/sports/models/sport-view-model";
import {EntityLogoRequestParams} from "../../../infrastructure/models/params/entity-logo-request-params";

const SPORT_TYPE_ICON_PATH = {
  notActive: 'NotActive',
  active: 'Active',
  hover: 'Hover',
}

export class SportTypeIconImageRequestParams extends EntityLogoRequestParams {
  id: Number;

  constructor(params, sport: SportViewModel) {
    super(params, sport);

    this.id = sport.id;
    this.resourceName = `website/sportTypes/${params.isHover ? SPORT_TYPE_ICON_PATH.hover : (params.isActive ? SPORT_TYPE_ICON_PATH.active : SPORT_TYPE_ICON_PATH.notActive)}`
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
